import { useState } from 'react';

export interface AlertState {
  isOpen: boolean;
  title: string;
  message: string;
  type: 'error' | 'success';
}

export interface ConfirmState<T = any> {
  isOpen: boolean;
  data: T | null;
  title: string;
  type?: string;
}

export function useAlert() {
  const [alert, setAlert] = useState<AlertState>({
    isOpen: false,
    title: '',
    message: '',
    type: 'success'
  });

  const showAlert = (title: string, message: string, type: 'error' | 'success' = 'success') => {
    setAlert({ isOpen: true, title, message, type });
  };

  const closeAlert = () => {
    setAlert(prev => ({ ...prev, isOpen: false }));
  };

  return { alert, showAlert, closeAlert, setAlert };
}

export function useConfirm<T = any>() {
  const [confirm, setConfirm] = useState<ConfirmState<T>>({
    isOpen: false,
    data: null,
    title: '',
  });

  const showConfirm = (title: string, data: T, type?: string) => {
    setConfirm({ isOpen: true, title, data, type });
  };

  const closeConfirm = () => {
    setConfirm(prev => ({ ...prev, isOpen: false, data: null }));
  };

  return { confirm, showConfirm, closeConfirm, setConfirm };
}

